module.exports = __webpack_public_path__ + "35ac8cb79942ddb0947f4db805468f9f.pdf";